import React from 'react'
import {Modal} from 'react-bootstrap'
import { getIsDefaultRegion } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useSelector } from 'react-redux'

type PriceListItem = {
  [key: string]: {
    sms: string
    oneSms: string
    mms: string
    oneMms: string
  }
}

type PriceList = {
  default: PriceListItem
  us: PriceListItem
}

const PriceViewPopup = ({show, handleClose}: any) => {
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const priceList: PriceList  = {
    default: {
      '10': {
        sms: '0.47',
        oneSms: '0.047',
        mms: '3.40',
        oneMms: '0.34',
      },
      '250': {
        sms: '10.75',
        oneSms: '0.043',
        mms: '85',
        oneMms: '0.34',
      },
      '1k': {
        sms: '37',
        oneSms: '0.037',
        mms: '330',
        oneMms: '0.33',
      },
      '5k': {
        sms: '155',
        oneSms: '0.031',
        mms: '1,550',
        oneMms: '0.31',
      },
      '20k': {
        sms: '580',
        oneSms: '0.029',
        mms: '5,800',
        oneMms: '0.29',
      },
      '100k': {
        sms: '2,8K',
        oneSms: '0.028',
        mms: '28K',
        oneMms: '0.28',
      },
    },
    us: {
      '10': {
        sms: '0.077',
        oneSms: '0.0077',
        mms: '0.20',
        oneMms: '0.02',
      },
      '250': {
        sms: '1.9',
        oneSms: '0.0076',
        mms: '5',
        oneMms: '0.02',
      },
      '1k': {
        sms: '7.5',
        oneSms: '0.0075',
        mms: '19',
        oneMms: '0.019',
      },
      '5k': {
        sms: '36.5',
        oneSms: '0.0073',
        mms: '95',
        oneMms: '0.019',
      },
      '20k': {
        sms: '138',
        oneSms: '0.0069',
        mms: '360',
        oneMms: '0.018',
      },
      '100k': {
        sms: '630',
        oneSms: '0.0063',
        mms: '1,8K',
        oneMms: '0.018',
      },
    } 
  }

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-1000px'
      className='vh-100 credit-modal sms-modal'
      show={show}
      onHide={handleClose}
    >
      <div className=''>
        <div className='modal-header'>
          <h5 className='modal-title'>Pricing</h5>
          <button type='button' className='close' onClick={handleClose} aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
        </div>
        <div className='modal-body'>
          <div className='pricing-container'>
            <div className='left'>
              {isDefaultRegion ? (
                <PriceListTable priceList={priceList.default} />
              ) : (
                <PriceListTable priceList={priceList.us} />
              )}
            </div>
            <div className='right'>
              <div className='get-start'>GETTING STARTED</div>
              <div className='pay-as'>Pay as you go, no subscription</div>
              <div className='features'>
                All features are included in our per message price listed below. Credits do not
                expire, so you can use them as and when required.
              </div>
              <div className='checks'>
                <div className='box'>
                  <i className='bi bi-check-circle-fill'></i>
                  <p>Pre-paid, no subscriptions!</p>
                </div>
                <div className='box'>
                  <i className='bi bi-check-circle-fill'></i>
                  <p>Credits do not expire</p>
                </div>
                <div className='box'>
                  <i className='bi bi-check-circle-fill'></i>
                  <p>Shared numbers FREE to use</p>
                </div>
              </div>
              <div
                className='competitor'
                onClick={() => {
                  window.open('https://www.smscomparison.com.au/reviews/cellcast-review/', '_blank')
                }}
              >
                <p>See competitor Price Comparison</p>
                <i className='bi bi-chevron-right'></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

const PriceListTable = ({priceList}: {priceList: PriceListItem} ) => (
  <div className='pricing9_plan'>
    <div className='pricing9_plan-tab top'>
      <div className='pricing9_plan-tab_text-container'>
        <h4 className='heading-style-h5 text-weight-medium text-white'>Credits</h4>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='heading-style-h5 text-weight-medium text-white'>SMS</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='heading-style-h5 text-weight-medium text-white'>MMS</h5>
      </div>
    </div>
    <div className='pricing9_plan-tab'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='text-weight-medium'>10</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['10']['sms']}</div>
        <div className='pricingbundles_sub-price'>1 SMS = ${priceList['10']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['10']['mms']}</div>
        <div className='pricingbundles_sub-price'>1 MMS = ${priceList['10']['oneMms']}</div>
      </div>
    </div>
    <div className='pricing9_plan-tab gray'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='text-weight-medium'>250</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['250']['sms']}</div>
        <div className='pricingbundles_sub-price'>1 SMS = ${priceList['250']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['250']['mms']}</div>
        <div className='pricingbundles_sub-price'>1 MMS = ${priceList['250']['oneMms']}</div>
      </div>
    </div>
    <div className='pricing9_plan-tab'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='text-weight-medium'>1K</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['1k']['sms']}</div>
        <div className='pricingbundles_sub-price'>1 SMS = ${priceList['1k']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['1k']['mms']}</div>
        <div className='pricingbundles_sub-price'>1 MMS = ${priceList['1k']['oneMms']}</div>
      </div>
    </div>
    <div className='pricing9_plan-tab gray'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='text-weight-medium'>5K</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['5k']['sms']}</div>
        <div className='pricingbundles_sub-price'>1 SMS = ${priceList['5k']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['5k']['mms']}</div>
        <div className='pricingbundles_sub-price'>1 MMS = ${priceList['5k']['oneMms']}</div>
      </div>
    </div>
    <div className='pricing9_plan-tab'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='text-weight-medium'>20K</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['20k']['sms']}</div>
        <div className='pricingbundles_sub-price'>1 SMS = ${priceList['20k']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='heading-style-h5 v4'>${priceList['20k']['mms']}</div>
        <div className='pricingbundles_sub-price'>1 MMS = ${priceList['20k']['oneMms']}</div>
      </div>
    </div>
    <div className='pricing9_plan-tab bottom'>
      <div className='pricing9_plan-tab_text-container'>
        <h5 className='pricingbundles_price purple-color'>100K</h5>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='pricingbundles_price'>${priceList['100k']['sms']}</div>
        <div className='pricingbundles_sub-price bottom'>1 SMS = ${priceList['100k']['oneSms']}</div>
      </div>
      <div className='pricing9_plan-tab_text-container'>
        <div className='pricingbundles_price'>${priceList['100k']['mms']}</div>
        <div className='pricingbundles_sub-price bottom'>1 MMS = ${priceList['100k']['oneMms']}</div>
      </div>
      <div id='most-popular' className='pricingbundles_banner'>
        <div>Most Popular - SAVE 40%</div>
      </div>
    </div>
  </div>
)

export default PriceViewPopup
